import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MessagesReportFilterForm } from 'src/app/shared/interfaces';

import { DataWithPagination } from '../../interface';
import { MessagesReportApi } from '../api/messages-report-api';
import { MessagesReport } from '../model';
import { Repository } from './repository';

@Injectable({
  providedIn: 'root',
})
export class MessagesReportRepository extends Repository {
  constructor(private messagesReportApi: MessagesReportApi) {
    super();
  }

  getMessagesReport(filter: MessagesReportFilterForm): Observable<DataWithPagination<MessagesReport[]>> {
    return this.messagesReportApi.getMessagesReport(filter);
  }
}


